"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FeTopNavList = _interopRequireDefault(require("./FeTopNavList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FeTopNav = function FeTopNav(_ref) {
  var feStyle = _ref.feStyle,
      className = _ref.className,
      navList = _ref.navList,
      productType = _ref.productType,
      leftContent = _ref.leftContent,
      rightContent = _ref.rightContent,
      additionalProps = _ref.additionalProps,
      customRenderLink = _ref.customRenderLink;
  var headerClassName = (0, _classnames.default)('fe-top-nav', {
    'fe-top-nav__topbar': feStyle === 'topbar',
    'fe-top-nav__topnav': feStyle === 'topnav'
  }, className);
  var leftClassName = (0, _classnames.default)('fe-top-nav__title', {
    'fe-top-nav__bookend fe-top-nav__bookend--left': feStyle === 'topnav'
  });
  var rightClassName = (0, _classnames.default)('fe-top-nav__action-container', {
    'fe-top-nav__bookend fe-top-nav__bookend--right': feStyle === 'topnav'
  });
  var headerProps = Object.assign({}, additionalProps);
  return _react.default.createElement("header", _extends({}, headerProps, {
    className: headerClassName
  }), _react.default.createElement("div", {
    className: leftClassName
  }, productType && _react.default.createElement("div", {
    className: "fe-product fe-product--".concat(productType)
  }), leftContent), _react.default.createElement(_FeTopNavList.default, {
    navList: navList,
    customRenderLink: customRenderLink
  }), _react.default.createElement("div", {
    className: rightClassName
  }, rightContent));
};

FeTopNav.defaultProps = {
  feStyle: 'topnav',
  productType: null,
  navList: [],
  onItemClick: null,
  customRenderLink: null
};
FeTopNav.propTypes = {
  /** Provide top navigation variants like 'topbar' or 'topnav'*/
  feStyle: _propTypes.default.oneOf(['topbar', 'topnav']),

  /** Provide productType like 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta'*/
  productType: _propTypes.default.oneOf(['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta']),

  /** Provide top nav list*/
  navList: _propTypes.default.arrayOf(_propTypes.default.object),

  /** Space for user defined node in left bookend*/
  leftContent: _propTypes.default.node,

  /** Space for user defined node in right bookend*/
  rightContent: _propTypes.default.node,

  /** Provide item click handler for nav items*/
  onItemClick: _propTypes.default.func,

  /** Additional props to pass on to the anchor */
  additionalProps: _propTypes.default.object,

  /** A function that returns a react element to render the wrapping link.
   *  Will receive url, className, and children props
   */
  customRenderLink: _propTypes.default.func
};
FeTopNav.displayName = 'FeTopNav';
var _default = FeTopNav;
exports.default = _default;